// extracted by mini-css-extract-plugin
export var activeFilterButton = "_r5-c";
export var backButton = "_r5-4";
export var backIcon = "_r5-5";
export var chevronShortcut = "_r5-6";
export var container = "_r5-1";
export var editor = "_r5-8";
export var editorWrapper = "_r5-7";
export var prefix = "_r5-2";
export var searchIcon = "_r5-3";
export var suffix = "_r5-9";
export var suffixContent = "_r5-a";
export var suffixText = "_r5-b";
export var wrapper = "_r5-0";